var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "791D5E2B-9F47-463E-A09D-0FB0E9361980") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "new_Q4_GVT-experience",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "GVT_AUTH_Scheduling_desktop",
    transform: "translate(-787.000000, -1024.000000)",
    fill: "#00095B"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Buttons-/-Text-/-Building-Blocks-/-+-Icon-/-on-dark",
    transform: "translate(611.000000, 1001.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Buttons-/-Text-/-Blue-/-With-Icon-/-Default",
    transform: "translate(24.000000, 16.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(152.000000, 7.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8,0 C8.24545989,0 8.44960837,0.176875161 8.49194433,0.410124368 L8.5,0.5 L8.5,7 L15.5,7 C15.7761424,7 16,7.22385763 16,7.5 C16,7.74545989 15.8231248,7.94960837 15.5898756,7.99194433 L15.5,8 L8.5,8 L8.5,15.5 C8.5,15.7761424 8.27614237,16 8,16 C7.75454011,16 7.55039163,15.8231248 7.50805567,15.5898756 L7.5,15.5 L7.5,8 L0.5,8 C0.223857625,8 0,7.77614237 0,7.5 C0,7.25454011 0.176875161,7.05039163 0.410124368,7.00805567 L0.5,7 L7.5,7 L7.5,0.5 C7.5,0.223857625 7.72385763,0 8,0 Z",
    id: "Icon-Fill-Color-",
    fill: "#0562d2"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusIcon);
export default __webpack_public_path__ + "static/media/plus-icon.23e662fc7b7ad08cf25f3116d5216c5c.svg";
export { ForwardRef as ReactComponent };